import { render, staticRenderFns } from "./ClickAndBuyLogoForm.vue?vue&type=template&id=3cfc35ab&scoped=true"
import script from "./ClickAndBuyLogoForm.vue?vue&type=script&lang=js"
export * from "./ClickAndBuyLogoForm.vue?vue&type=script&lang=js"
import style0 from "./ClickAndBuyLogoForm.vue?vue&type=style&index=0&id=3cfc35ab&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cfc35ab",
  null
  
)

export default component.exports